
import { Component, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import InputFieldMixin from '~/components/Inputs/InputFieldMixin';
import TextInput from '~/components/Inputs/Text.vue';
import emailValidator from '~/validators/email_address';

@Component({ components: { TextInput } })
export default class Email extends mixins(InputFieldMixin) {
  @Prop(Boolean) showIcon!: boolean;

  defaultLabelAttr = 'Email';

  defaultDataTestAttr = 'emailInput';

  validateEmail(value: string): string | boolean {
    if (!value) return this.isRequired();

    if (!emailValidator(value)) return 'Please correct email format';

    return true;
  }
}
